<div class="container-fluid mt-4 px-3">
  <div class="container-shadow px-3">
    <div *ngIf="loading" class="m-5 p-5 text-center">
      <i class="fas fa-fw fa-spinner fa-pulse fa-5x"></i>
    </div>
    <div *ngIf="!loading">
      <h4 class="py-3">{{ autoRedirectRule.id ? 'Editing Auto Redirect Rule' : 'New Auto Redirect Rule' }}</h4>
      <div class="row">
        <div class="col-md-6">
          <div style="max-width: 40rem">
            <div class="form-group">
              <app-matter-search [matterId]="autoRedirectRule.matter_id" (matter_id)="autoRedirectRule.matter_id = $event"></app-matter-search>
              <small class="form-text text-muted">Leave matter blank and rule will apply to all matters</small>
            </div>
            <div class="form-group">
              <app-document-type-search [documentTypeId]="autoRedirectRule.document_type_id" (document_type_id)="autoRedirectRule.document_type_id = $event"></app-document-type-search>
            </div>
            <div class="form-group">
              <label>Destination</label>
              <select class="form-control" name="destination" [(ngModel)]="autoRedirectRule.destination">
                <option *ngFor="let destination of formOptions.destinations" [value]="destination.value">{{ destination.label }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Special Instructions</label>
              <textarea class="form-control" [(ngModel)]="autoRedirectRule.instructions" name="instructions"></textarea>
            </div>
            <div class="form-group">
              <label>Minimum Priority</label>
              <select class="form-control" name="minimum_priority" [(ngModel)]="autoRedirectRule.minimum_priority">
                <option *ngFor="let priority of formOptions.priorities" [value]="priority.value">{{ priority.label }}</option>
              </select>
            </div>
            <div class="form-group text-center">
              <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
                {{ saving ? 'Saving' : 'Save' }}<span *ngIf="saving">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
              </button>
              &nbsp;&nbsp;
              <button type="button" (click)="back()" [disabled]="saving" class="btn btn-outline-secondary">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="py-3"></div>
    </div>
  </div>
</div>
